import { useMemo } from "react";
import { useDialog } from "@shared/features/dialog/useDialog";
import { SupportArticleSheet } from "./SupportArticleSheet";
import { useSupport } from "../../SupportContext";
import { useSupportSheet } from "../../hooks/useSupportSheet";
import { useArticleNavigation } from "../../hooks/useArticleNavigation";

export function SupportArticleSheetContainer() {
  const { openDialog } = useDialog();

  const { articles, categories, isSheetOpen } = useSupport();

  const { sheetArticleId, closeSheet, setSheetArticleId } = useSupportSheet();

  const article = useMemo(() => {
    return articles.find((article) => article.id === sheetArticleId);
  }, [sheetArticleId, articles]);

  const { prev, next } = useArticleNavigation({
    articleId: sheetArticleId ?? null,
  });

  const handleSearchClick = () => {
    openDialog("supportSearch");
  };

  const handleTicketClick = () => {
    openDialog("supportTicket");
  };

  return (
    <SupportArticleSheet
      article={article}
      categories={categories}
      isOpen={isSheetOpen}
      onClose={closeSheet}
      prev={prev}
      next={next}
      setSheetArticleId={setSheetArticleId}
      onSearchClick={handleSearchClick}
      onTicketClick={handleTicketClick}
    />
  );
}

export default SupportArticleSheetContainer;
